<template>
  <v-container class="mt-0">
      <v-layout row wrap justify-center v-if="loading">
        <v-flex xs12 sm8 md6 class="text-xs-center">
          <v-progress-circular 
          indeterminate 
          color="primary"
          :width="7"
          :size="70"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
        <h1 class="mt-3 text-xs-center">{{ location.locationName }}</h1>
        
				<v-expansion-panel expand>
					<v-expansion-panel-content>
						<div slot="header">Street Address</div>
						<v-card>
							<v-card-text class="grey lighten-3">{{ location.locationStreetAddress }}</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>
				<v-expansion-panel expand>
					<v-expansion-panel-content>
						<div slot="header">City</div>
						<v-card>
							<v-card-text class="grey lighten-3">{{ location.locationCity }}</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>								
				<v-expansion-panel expand>
					<v-expansion-panel-content>
						<div slot="header">State</div>
						<v-card>
							<v-card-text class="grey lighten-3">{{ location.locationState }}</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>								
				<v-expansion-panel expand>
					<v-expansion-panel-content>
						<div slot="header">Zipcode</div>
						<v-card>
							<v-card-text class="grey lighten-3">{{ location.locationZipcode }}</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>								
        <v-divider></v-divider>
				<template v-if="userIsAuthenticated">
					<v-spacer></v-spacer>
					<app-edit-location-dialog :location="location"></app-edit-location-dialog>
				</template>				
        <v-btn dark flat class="red darken-3" @click="onDeleteLocation(location)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },
  props: ['id'],
  methods: {
    onDeleteLocation (location) {
      console.log('Delete this: ' + JSON.stringify(location))
      this.$store.dispatch('deleteLocationData', location)
      this.$router.push('/locations')
    }
  },
  computed: {
    location () {
      return this.$store.getters.loadedLocation(this.id)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.location.creatorId
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>


// WEBPACK FOOTER //
// Location.vue?b8c3831a